import { useMemo } from "react";
import { useAppSelector } from "../../../store/hooks";
import MetadataComponent from "../MetadataComponent";
import usePageLanguage from "../hooks/usePageLanguage";
import {
  getCatalogProductPageSeo,
  getCatalogProductSlug,
} from "../utilities/catalogProductAdapter";
import type { Product } from "../interfaces/catalogProduct";
import React from "react";

type ProductMetadataProps = {
  product: Product | null;
};

export default function ProductMetadata({ product }: ProductMetadataProps) {
  const locale = usePageLanguage();
  const pages = useAppSelector((state) => state.builder.pages.list) as Array<{
    pageType?: string;
    languageCode?: string;
    url?: string;
  }>;

  const pageSeo = useMemo(() => {
    if (!product) {
      return undefined;
    }

    const merged = getCatalogProductPageSeo(product, locale);
    if (!merged) {
      return undefined;
    }

    const productPage = pages.find(
      (page) => page.pageType === "product" && page.languageCode === locale
    );
    if (productPage?.url) {
      const segment =
        getCatalogProductSlug(product, locale) ?? product.productUuid;
      if (segment) {
        merged.canonical = `${window.location.origin}/${locale}/${productPage.url}/${segment}`;
      }
    }

    return merged;
  }, [product, locale, pages]);

  if (!pageSeo) {
    return null;
  }

  return <MetadataComponent page_seo={pageSeo} />;
}
